import rawDataset from './generated/week-summary.json';

export type WeeklyDatum = {
  dateLabel: string;
  startDate: string;
  endDate: string;
  sessions: number;
  minutes: number;
};

export type Peak = {
  index: number;
  value: number;
  dateLabel: string;
};

export type Dataset = {
  rows: WeeklyDatum[];
  summary: {
    count: number;
    sourceCount: number;
    filteredCount: number;
    filter: {minSessions: number};
    totals: {sessions: number; minutes: number};
    averages: {sessions: number; minutes: number};
    ranges: {
      sessions: {min: number; max: number};
      minutes: {min: number; max: number};
    };
    peaks: {sessions: Peak; minutes: Peak};
    startDate: string;
    endDate: string;
  };
};

export const dataset = rawDataset as Dataset;
